import { ENGLISH_IQ_DAILY_TARGET_MINUTES } from '@repo/config';
import { z } from 'zod';

const dailyTargetMinutesSchema = z.union([
  z.literal(ENGLISH_IQ_DAILY_TARGET_MINUTES[0]),
  z.literal(ENGLISH_IQ_DAILY_TARGET_MINUTES[1]),
  z.literal(ENGLISH_IQ_DAILY_TARGET_MINUTES[2]),
]);

export const saveEnglishIqPlanV1RequestSchema = z.object({
  dailyTargetMinutes: dailyTargetMinutesSchema,
  handoffToken: z.string().min(1).optional(),
  shareId: z.string().min(6).max(64),
  visitorId: z.string().min(1).max(128).optional(),
});

export type ISaveEnglishIqPlanV1Request = z.infer<typeof saveEnglishIqPlanV1RequestSchema>;
